import { Component, inject } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideHouse } from '@ng-icons/lucide';
import { HlmBreadcrumbImports } from '@spartan-ng/helm/breadcrumb';
import { HlmSeparator } from '@spartan-ng/helm/separator';
import { HlmSidebarTrigger } from '@spartan-ng/helm/sidebar';
import { PortalModule } from '@angular/cdk/portal';
import { TitleService } from '@core/services/title.service';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { BreadcrumbService } from '@core/services/breadcrumb.service';
import { PageBarService } from '@core/services/page-bar.service';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  imports: [
    NgIcon,
    HlmBreadcrumbImports,
    HlmSeparator,
    HlmSidebarTrigger,
    PortalModule,
    HlmSpinnerImports
  ],
  providers: [provideIcons({ lucideHouse })]
})
export class PageHeaderComponent {
  protected titleService = inject(TitleService);
  protected breadcrumbService = inject(BreadcrumbService);
  protected pageBar = inject(PageBarService);
}
